import { createNoise2D } from "simplex-noise";
import alea from "alea";

export default class CurlSimple
{
    constructor (canvas)
    {
        this.canvas = canvas;

        this.ctx = this.canvas.getContext("2d");
        this.canvas.width = window.innerWidth;
        this.canvas.height = window.innerHeight;
        this.TWO_PI = 2 * Math.PI;

        this.red = [];
        this.grn = [];
        this.blu = [];

        this.center = 128;
        this.width = 127;
        this.frequency1 = 0.3;
        this.frequency2 = 0.3;
        this.frequency3 = 0.3;

        this.phase1 = 0;
        this.phase2 = 2;
        this.phase3 = 4;

        this.discCount = 1000;

        for (let s = 0; s < this.discCount; s++) {

            let color = this.getColorAtIndex(s);

            this.red[s] = Math.round(Math.sin(this.frequency1*s + this.phase1) * this.width + this.center);
            this.grn[s] = Math.round(Math.sin(this.frequency2*s + this.phase2) * this.width + this.center);
            this.blu[s] = Math.round(Math.sin(this.frequency3*s + this.phase3) * this.width + this.center);
        }

        this.create();

        var dx = 4;
        var dy = 4;

        this.time = 0.0000000000000001;

        var width = (window.innerWidth/dx) << 0;
        var height = (window.innerHeight/dy) << 0;
        var size = width * height;

        var noise_ = [];

        var ellipse_width = dx/3;
        var ellipse_height = dy/3;

        var offset_start = Math.PI/2;
        var offset_end = 1.5*Math.PI;

        var target_x = this.canvas.width/2;
        var target_y = this.canvas.height/2;

        const prng = alea('Eléonore Benoit-Tremblay');
        this.noise = createNoise2D (prng);


        this.variables = {
            speed: 2.8,
            fade: 0.1,
            step: 1600,
            particle_size: 2.5,
            rainbow: true,
            lighten: false,
            colour: '#ff9500'
        }

        this.mouseSpeed = 2;

        document.addEventListener("mousemove", this.calculateMouseSpeed.bind(this));

        this.cpt =0;
        //this.resetNoise()
        this.dampSpeed()

        this.draw();
    }

    dampSpeed ()
    {
        requestAnimationFrame(() => this.dampSpeed())

        //if (this.mouseSpeed > 0)
        {
            this.mouseSpeed *= 0.995;
            this.variables.speed = this.mouseSpeed;
        }
    }
    resetNoise ()
    {
        const prng = alea(this.cpt++);
        this.noise = createNoise2D (prng);
    }

    calculateMouseSpeed (event)
    {
        this.mouseX = event.pageX;
        this.mouseY = event.pageY;

        if (this.lastMouseX === undefined)
        {
            this.lastMouseX = this.mouseX;
            this.lastMouseY = this.mouseY;
        }

        let speed = Math.sqrt( Math.pow(this.mouseX - this.lastMouseX, 2) + Math.pow(this.mouseY - this.lastMouseY, 2) );
        this.lastMouseX = this.mouseX;
        this.lastMouseY = this.mouseY;

        let diff = (this.mouseSpeed - speed) / 2000;
        this.mouseSpeed += diff;
        this.variables.speed = this.mouseSpeed;
    }

    onMouseMove2 (event)
    {
        this.mouseX = event.pageX;
        this.mouseY = event.pageY;

        const prng = alea(this.mouseX + "_" + this.mouseY);
        this.noise = createNoise2D (prng);

    }

    getColorAtIndex (index)
    {
        let blue = index % 50 === 0;
        let green = index % 50 === 25;

        if (blue)
            return [20,20, 255];
        if (green)
            return [20, 255, 20];

        return [200, 20, 20];
    }
    create ()
    {
        this.discs = [];

        for(let i = 0; i < this.discCount; i++){
            let style = 'rgba('+this.red[i]+','+this.grn[i]+','+this.blu[i]+', 1)';
            let disc = {
                x: this.canvas.width / 4 + Math.random() * (this.canvas.width / 2),
                y: this.canvas.height / 4 + Math.random() * (this.canvas.height / 2),
                x_vel: 0,
                y_vel: 0,
                radius: 3,
                colour: style
            };
            this.discs.push(disc);
        }
    }

    move() {
        for(let i = 0; i < this.discCount; i++)
        {
            if(this.discs[i].x < this.discs[i].radius){
                this.discs[i].x = Math.random()*this.canvas.width;
                this.discs[i].y = Math.random()*this.canvas.height;
            }
            if(this.discs[i].y < this.discs[i].radius){
                this.discs[i].x = Math.random()*this.canvas.width;
                this.discs[i].y = Math.random()*this.canvas.height;
            }
            if(this.discs[i].x > this.canvas.width-this.discs[i].radius){
                this.discs[i].x = Math.random()*this.canvas.width;
                this.discs[i].y = Math.random()*this.canvas.height;
            }
            if(this.discs[i].y > this.canvas.height-this.discs[i].radius){
                this.discs[i].x = Math.random()*this.canvas.width;
                this.discs[i].y = Math.random()*this.canvas.height;
            }
            this.discs[i].x += this.discs[i].x_vel;
            this.discs[i].y += this.discs[i].y_vel;
        }
    }

    computeCurl(x, y)
    {
        var eps = this.time;
        var n1 = this.noise(x, y + eps);
        var n2 = this.noise(x, y - eps);
        var a = (n1 - n2)/(2 * eps);

        n1 = this.noise(x + eps, y);
        n2 = this.noise(x - eps, y,);
        var b = (n1 - n2)/(2 * eps);



        return [a, -b];
    }


    draw()
    {

        this.ctx.fillStyle = "rgba(2,49,70, "+this.variables.fade+")";
        this.ctx.fillRect(0,0,window.innerWidth, window.innerHeight);

        this.move();

        this.ctx.save();
        if(this.variables.lighten){
            this.ctx.globalCompositeOperation = "lighten";
        }
        for(let i = 0; i < this.discs.length; i++){
            if(this.variables.rainbow){
                this.ctx.fillStyle = this.discs[i].colour;
            }else{
                this.ctx.fillStyle = this.variables.colour;
            }

            var curl = this.computeCurl(this.discs[i].x/this.variables.step, this.discs[i].y/this.variables.step);


            let diffX = 0;//this.mouseX ? (this.mouseX - this.discs[i].x) / 200 : 0;
            let diffY = 0;//this.mouseY ? (this.mouseY - this.discs[i].y) / 200 : 0;
            this.discs[i].x_vel = this.variables.speed*curl[0] + diffX;
            this.discs[i].y_vel = this.variables.speed*curl[1] + diffY;



            this.ctx.beginPath();
            this.ctx.arc(this.discs[i].x, this.discs[i].y, this.variables.particle_size, 0, this.TWO_PI);
            this.ctx.fill();
        }
        this.ctx.restore();

        this.time += 0.000001;
        window.requestAnimationFrame(() => this.draw());
    }
}
